import { GenderEnum } from '../../../enums/GenderEnum'
import Avatar from '../ImageAvatars/Avatar'
import { RaytebRequests } from '../../../_services'
import { PrescriptionViewModel } from '../../../models/ViewModels/PrescriptionViewModel'
import { useNavigate } from 'react-router'
import { addOrUpdatePrescription } from '../../../storeManager/Reducers/prescriptionSlice'
import { useDispatch, useSelector } from 'react-redux'
import useFetch from '../../../_services/fetch'
import LoadingFit from '../Loading/LoadingFit'
import { Icon } from '../../Elements'
import { ReducerType } from '../../../storeManager/ReducerType'

const SamadDeliveredCard: React.FC<SamadCardDeliveredInterface> = ({
  model,
  centerId,
  token,
}) => {
  const dispatch = useDispatch()
  const navigation = useNavigate()
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const { isLoading, reFetch } = useFetch<PrescriptionViewModel, Object>({
    request: RaytebRequests.Prescription_Get_POST({
      headers: { centerId: centerId },
      token: token,
    }),
    onSuccess(data) {
      dispatch(addOrUpdatePrescription(data))
      navigation('/prescription/newPrescription')
    },
  })

  return (
    <>
      <div className='p-2 grid grid-cols-8 bg-white shadow-inner rounded-sm gap-4 relative'>
        <LoadingFit isLoading={isLoading} />
        <div className='col-span-2 '>
          <Avatar url={model.image ?? null} className='!h-16 !w-16' />
        </div>
        <div className='col-span-6 pt-3 px-3 flex flex-col justify-center items-start gap-2'>
          <div className='w-full flex justify-between items-center'>
            <h2 className='text-sm font-bold '>{`${model.firstName} ${model.lastName}`}</h2>

            {model.ticketId && (center.hasPrescription || center.hasRecord) ? (
              <Icon
                icon='rayteb-edit'
                className='text-xl text-warn'
                onClick={() => {
                  reFetch({
                    code: model.personCode,
                    ticketId: model.ticketId,
                  })
                }}
              />
            ) : (
              ''
            )}
          </div>
          <div className='flex w-full justify-between items-center'>
            <span className='text-xs text-primaryLight'>
              {model.personCode}
            </span>
            <span className='text-xs text-primaryLight'>
              {model.productName}
            </span>
            <p className='flex justify-center items-center gap-2 text-xs font-bold text-primaryLight'>
              <span>{GenderEnum[model.gender]}</span>
              <span>{model.age}</span>
            </p>
          </div>
        </div>
        <div className='col-span-8 mt-2 flex  justify-around items-center gap-2 text-[11px]'>
          <span className=' text-primary font-bold'>
            {`کد رهگیری : ${model.trackingCode}`}
          </span>
          {model.deletedDate ? (
            <span className=' text-primary font-bold'>
              {`تاریخ حذف : ${new Date(model.deletedDate!).toShamsi()}`}
            </span>
          ) : (
            ''
          )}
          {model.insuranceExpireDate ? (
            <span className=' text-primary font-bold'>
              {`اعتبار بیمه : ${new Date(
                model.insuranceExpireDate!
              ).toShamsi()}`}
            </span>
          ) : (
            ''
          )}
          {model.deliveredDate ? (
            <span className=' text-primary font-bold'>
              {`تاریخ ارائه : ${new Date(model.deliveredDate!).toShamsi()}`}
            </span>
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  )
}

export default SamadDeliveredCard
